import gql from 'graphql-tag';

export const financialApplicationFragment = gql`{
  id
  user {id firstName lastName email username}
  highSchoolYear
  residenceState
  currentBalance
}`
